import type { UserGroup, Permission } from '../types/userRole';

export const mockPermissions: Permission[] = [
  {
    id: '1',
    name: 'Full Access',
    type: 'full-access',
    color: '#E74C3C'
  },
  {
    id: '2',
    name: 'Booking Management',
    type: 'booking-management',
    color: '#4472C4'
  },
  {
    id: '3',
    name: 'Customer Service',
    type: 'customer-service',
    color: '#28A745'
  },
  {
    id: '4',
    name: 'Financial Data',
    type: 'financial-data',
    color: '#FFC107'
  },
  {
    id: '5',
    name: 'Policy Management',
    type: 'policy-management',
    color: '#6F42C1'
  },
  {
    id: '6',
    name: 'Content Management',
    type: 'content-management',
    color: '#E91E63'
  },
  {
    id: '7',
    name: 'Technical Support',
    type: 'technical-support',
    color: '#17A2B8'
  },
  {
    id: '8',
    name: 'Employee Management',
    type: 'employee-management',
    color: '#FD7E14'
  }
];

export const mockUserGroups: UserGroup[] = [
  {
    id: 1,
    name: 'Administrator',
    groupId: 'Group ID: 1',
    memberCount: 12,
    permissions: [mockPermissions[0]], // Full Access
    selected: false
  },
  {
    id: 2,
    name: 'Travel Agency',
    groupId: 'Group ID: 2',
    memberCount: 8,
    permissions: [mockPermissions[1]], // Booking Management
    selected: false
  },
  {
    id: 3,
    name: 'Frontliner',
    groupId: 'Group ID: 3',
    memberCount: 15,
    permissions: [mockPermissions[2]], // Customer Service
    selected: false
  },
  {
    id: 4,
    name: 'Accounting',
    groupId: 'Group ID: 4',
    memberCount: 6,
    permissions: [mockPermissions[3]], // Financial Data
    selected: false
  },
  {
    id: 5,
    name: 'Policy',
    groupId: 'Group ID: 5',
    memberCount: 4,
    permissions: [mockPermissions[4]], // Policy Management
    selected: false
  },
  {
    id: 6,
    name: 'Marketing',
    groupId: 'Group ID: 6',
    memberCount: 10,
    permissions: [mockPermissions[5]], // Content Management
    selected: false
  },
  {
    id: 7,
    name: 'Support',
    groupId: 'Group ID: 7',
    memberCount: 20,
    permissions: [mockPermissions[6]], // Technical Support
    selected: false
  },
  {
    id: 8,
    name: 'HR',
    groupId: 'Group ID: 8',
    memberCount: 5,
    permissions: [mockPermissions[7]], // Employee Management
    selected: false
  }
];